import React, { useEffect } from "react"
import { StorageWarningModal } from "./Modals"
import { useStorageContext } from "../contexts/StorageContext"
import SnackbarAlert from "./SnackbarAlert"

const StorageWarning = () => {
    const { storageWarning, setStorageWarning, storageCritical, setStorageCritical } = useStorageContext()

    const handleCloseWarning = () => setStorageWarning(false)
    const handleCloseCritical = () => setStorageCritical(false)

    useEffect(() => {
        const handleOnline = () => {
            if (storageCritical && navigator.onLine) {
                handleCloseCritical()
            }
        }

        window.addEventListener("online", handleOnline)

        return () => {
            window.removeEventListener("online", handleOnline)
        }
    }, [storageCritical])

    return (
        <>
            {/* 90% Warning Snackbar */}
            <SnackbarAlert
                open={storageWarning}
                message="Your storage is almost full (90%). Please sync your data soon."
                onClose={handleCloseWarning}
            />

            {/* 95% Critical Storage Modal */}
            {storageCritical && (
                <StorageWarningModal
                    open={storageCritical}
                    onClose={handleCloseCritical}
                    title="Critical Storage Alert"
                    storageCritical={storageCritical}
                    description="Storage is 95% full. Please connect to the internet to sync data."
                />
            )}
        </>
    )
}

export default StorageWarning
